import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: "/", label: "首页" },
    { to: "/category/romance", label: "分类" },
    { to: "/about", label: "关于我们" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span
            className="text-2xl font-bold tracking-tight"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            <span className="text-primary-500">韩漫</span>
            <span className={scrolled ? "text-foreground-950" : "text-white"}>世界</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.to
                  ? "text-primary-500"
                  : scrolled
                    ? "text-foreground-700 hover:text-primary-500"
                    : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <button
            className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 ${
              scrolled
                ? "text-foreground-600 hover:text-primary-500 hover:bg-background-100"
                : "text-white/80 hover:text-white hover:bg-white/10"
            }`}
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <button
            className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 ${
              scrolled
                ? "text-foreground-600 hover:text-primary-500 hover:bg-background-100"
                : "text-white/80 hover:text-white hover:bg-white/10"
            }`}
            aria-label="收藏"
          >
            <i className="ri-bookmark-line text-lg"></i>
          </button>
        </div>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full ${
            scrolled ? "text-foreground-700" : "text-white"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                location.pathname === link.to
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="flex gap-3 pt-2 border-t border-background-200/70">
            <button className="flex-1 py-2 px-3 rounded-lg text-sm text-foreground-600 hover:bg-background-100 transition-colors flex items-center justify-center gap-1 whitespace-nowrap">
              <i className="ri-search-line"></i> 搜索
            </button>
            <button className="flex-1 py-2 px-3 rounded-lg text-sm text-foreground-600 hover:bg-background-100 transition-colors flex items-center justify-center gap-1 whitespace-nowrap">
              <i className="ri-bookmark-line"></i> 收藏
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}